import React from 'react';
import { cn } from '../../lib/utils';

export interface CompanySelectorProps {
  companies: Array<{ company_name: string; [key: string]: any }>;
  selectedIndex: number;
  onSelect: (index: number) => void;
  className?: string;
}

export default function CompanySelector({
  companies,
  selectedIndex,
  onSelect,
  className,
}: CompanySelectorProps) {
  if (!companies || companies.length === 0) return null;

  // If only one company, just show the name without selector
  if (companies.length === 1) {
    return (
      <div className={cn('flex items-center gap-2', className)}>
        <span className="material-symbols-outlined text-slate-400 text-[20px]">apartment</span>
        <span className="text-sm font-medium text-slate-700">{companies[0].company_name}</span>
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="material-symbols-outlined text-slate-400 text-[20px]">apartment</span>
      <div className="flex gap-1 bg-slate-100 rounded-lg p-1">
        {companies.map((company, index) => (
          <button
            key={index}
            onClick={() => onSelect(index)}
            className={cn(
              'px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
              index === selectedIndex
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-600 hover:text-slate-900'
            )}
          >
            {company.company_name}
          </button>
        ))}
      </div>
    </div>
  );
}
